/**
 * 가입 대기·휴면·탈퇴 안내 (/m/member/wait) — 대기·휴면은 풀림을 감시해 앱 홈으로
 * ($j.Pages.Mobile.MemberWait / body data-page-name="MemberWait")
 */
export default class MemberWait {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        // 풀림 감지 — 휴면(2)·대기(1)만. 탈퇴 안내는 감시할 것이 없다.
        const WATCH    = D.watch;
        const INTERVAL = 10000;                    // 10초 — 5초는 배터리만 먹는다. 통화 끝나고 돌아오면 복귀 감지가 즉시 본다
        const WELCOME  = 'm:member:welcome';       // 메인 도착 시 환영 토스트 1회 (Pages/Mobile/Alim.js 가 읽고 지운다)
        if (!WATCH) return;

        let timer = null, busy = false;

        function toMain() {
            $j.Common.Store.session.set(WELCOME, '1');
            location.replace('/m/alim');
        }

        function check() {
            if (busy) return;
            busy = true;
            $.ajax({ url: '/m/ajax/member/info', type: 'get', dataType: 'json', cache: false })
                .done(toMain)                                   // 200 = 게이트를 지났다 = 정상(0)
                .fail(function (xhr) {
                    // 403 이면 아직 묶여 있다. 다만 다른 상태(예: 휴면→대기·탈퇴)로 바뀌었으면 문구를 다시 그린다.
                    // 401/419 는 Common/Network.js 가 로그인으로 보내므로 여기서 손대지 않는다.
                    if (xhr.status !== 403) return;
                    const st = parseInt((xhr.responseJSON || {}).status, 10);
                    if (!isNaN(st) && st !== WATCH) location.replace('/m/member/wait');
                })
                .always(function () { busy = false; });
        }

        function start() { stop(); check(); timer = setInterval(check, INTERVAL); }
        function stop()  { if (timer) { clearInterval(timer); timer = null; } }

        // 백그라운드·통화 중엔 멈추고, 돌아오면 바로 한 번 본다
        document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
        window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
        // 무음 폴백 — 자동 감지가 다 놓쳐도 화면을 한 번 탭하면 다시 본다 (버튼은 두지 않는다)
        document.getElementById('wt-body').addEventListener('click', check);

        start();
    }
}
